export default __webpack_public_path__ + "static/example-subpage-bg-d25c686d2e22e40022d26a0cd2fd6aea.jpg";